module.exports = __webpack_public_path__ + "img/icon-close-light.6265734a.svg";